import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import DropdownWithSearch from "../DropdownWithSearch";
import ConfirmationDialog from "../ConfirmationDialog";
import RegistrationFormHeading from "../../new-components/RegistrationFormHeading";
import { FiCheckCircle, FiTrash2, FiX } from "react-icons/fi";
import {
  formatAppointmentDate,
  getNextWeekdayDate,
  toLocalIsoDate,
} from "../../utils/appointmentDate";
import {
  deleteEventAppointment,
  getAppointmentDocumentId,
} from "../../services/appointmentService";
import {
  getAppointmentSelectionLabel,
  getSelectableAppointmentIds,
  toggleAllAppointmentSelection,
  toggleAppointmentSelection,
} from "../../utils/appointmentSelection";

const EventSingle = (props) => {
  const { id: routeId } = useParams();
  const id = props.eventId || routeId;
  const [eventsDetails, setEventsDetails] = React.useState();
  const [eventAppointments, setEventAppointments] = React.useState();
  const [userAppointment, setUserAppointment] = React.useState();
  const { user } = props.user;
  const isAdmin = Boolean(
    user?.email &&
    (user.email === process.env.REACT_APP_ADMIN ||
      user.email === process.env.REACT_APP_ARI_ADMIN)
  );
  const [userName, setUserName] = React.useState("");
  const [userLastname, setLastname] = React.useState("");
  const [userPhone, setUserPhone] = React.useState("");
  const [userCity, setUserCity] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [appointmentMode, setAppointmentMode] = React.useState("Online");
  const [confirmation, setConfirmation] = React.useState(null);
  const [selectedAppointmentIds, setSelectedAppointmentIds] = React.useState(new Set());
  const [deleteDialogAppointments, setDeleteDialogAppointments] = React.useState([]);
  const [isDeletingAppointments, setIsDeletingAppointments] = React.useState(false);
  const selectAllCheckboxRef = React.useRef(null);

  const dates = ["Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă", "Duminică"]; // Zilele disponibile
  const [isScheduling, setIsScheduling] = React.useState(false); // Controls whether the scheduling interface is shown
  const [selectedDates, setSelectedDates] = React.useState(dates[0] || "");
  const [selectedDay, setSelectedDay] = React.useState(""); // Ziua selectată

  const [isDateValid, setIsDateValid] = React.useState(true); // Stare pentru validarea datei
  const [isTimeValid, setIsTimeValid] = React.useState(true); // Stare pentru validarea orei

  const filteredAppointments = selectedDay
    ? eventAppointments?.filter((appointment) => appointment.selectedDates === selectedDay)
    : eventAppointments; // Dacă nu este selectată nicio zi, afișează toate programările

  // const generateTimeSlots = () => {
  //   const timeSlots = [];
  //   for (let hour = 8; hour < 18; hour++) {
  //     for (let minute = 0; minute < 60; minute += 10) {
  //       const formattedHour = hour.toString().padStart(2, "0");
  //       const formattedMinute = minute.toString().padStart(2, "0");
  //       timeSlots.push(`${formattedHour}:${formattedMinute}`);
  //     }
  //   }
  //   return timeSlots;
  // };
  const generateTimeSlots = () => {
    const timeSlots = [];
    for (let hour = 10; hour <= 18; hour += 2) { // Ore din 2 în 2
      const formattedHour = hour.toString().padStart(2, "0");
      timeSlots.push(`${formattedHour}:00`); // Adaugă doar ora fără minute
    }
    return timeSlots;
  };

  const fetchEventData = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/event/id/get?id=${id}`
    );
    setEventsDetails(result.data);
  };

  const fetchAppointmentsData = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/appointment/get?id=${id}`
    );
    setEventAppointments(result.data);
  };

  const requestDeleteAppointments = (appointments) => {
    const validAppointments = (appointments || []).filter(getAppointmentDocumentId);
    if (!validAppointments.length) {
      toast.error("Înscrierea nu are un identificator valid.");
      return;
    }

    setDeleteDialogAppointments(validAppointments);
  };

  const confirmDeleteAppointments = async () => {
    if (!deleteDialogAppointments.length) return;

    setIsDeletingAppointments(true);
    const results = await Promise.allSettled(
      deleteDialogAppointments.map((appointment) =>
        deleteEventAppointment(id, getAppointmentDocumentId(appointment))
      )
    );
    const deletedIds = new Set(
      results
        .map((result, index) => result.status === "fulfilled"
          ? getAppointmentDocumentId(deleteDialogAppointments[index])
          : ""
        )
        .filter(Boolean)
    );

    if (deletedIds.size) {
      setEventAppointments((current) =>
        (current || []).filter((item) => !deletedIds.has(getAppointmentDocumentId(item)))
      );
      setEventsDetails((current) => current
        ? {
          ...current,
          appointments: Math.max(0, Number(current.appointments || 0) - deletedIds.size),
        }
        : current
      );
      setSelectedAppointmentIds((current) => {
        const next = new Set(current);
        deletedIds.forEach((appointmentId) => next.delete(appointmentId));
        return next;
      });
    }

    const failedCount = results.length - deletedIds.size;
    if (deletedIds.size) {
      toast.success(deletedIds.size === 1
        ? "Programarea a fost ștearsă."
        : `${deletedIds.size} programări au fost șterse.`
      );
    }
    if (failedCount) {
      toast.error(failedCount === 1
        ? "O programare nu a putut fi ștearsă."
        : `${failedCount} programări nu au putut fi șterse.`
      );
    }

    setIsDeletingAppointments(false);
    setDeleteDialogAppointments([]);
  };

  React.useEffect(() => {
    fetchEventData();
    fetchAppointmentsData();
  }, []);

  React.useEffect(() => {
    if (userCity !== "Sibiu" && appointmentMode === "Fizic") {
      setAppointmentMode("Online");
    }
  }, [userCity, appointmentMode]);

  const updateEventAppointments = async (id) => {
    const eventData = {
      id: id,
      title: eventsDetails.title,
      author: eventsDetails.author,
      // createDate: eventsDetails.createDate,
      appointments: (eventAppointments?.length || 0) + 1,
      text: eventsDetails.text,
      coverImage: eventsDetails.coverImage,
    };

    // Log the data being sent
    console.log('Sending Event Data:', eventData);

    await axios.post(
      `${process.env.REACT_APP_API_BASE}/event/post?id=${id}`,
      eventData
    );
  };
  const postAppointment = async (e) => {
    e.preventDefault();

    let isValid = true;

    if (!userName.trim() || !userLastname.trim() || !userPhone.trim() || !userCity) {
      toast.warning("Completează toate datele de contact.");
      isValid = false;
    }

    if (!selectedDates) {
      setIsDateValid(false); // Marchează câmpul de dată ca invalid
      isValid = false;
    } else {
      setIsDateValid(true); // Resetează validarea pentru dată
    }

    if (!userAppointment) {
      setIsTimeValid(false); // Marchează câmpul de oră ca invalid
      isValid = false;
    } else {
      setIsTimeValid(true); // Resetează validarea pentru oră
    }

    if (!isValid) {
      return; // Oprește trimiterea formularului dacă există erori
    }

    try {
      setIsSubmitting(true);
      const appointmentDate = getNextWeekdayDate(selectedDates);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/appointment/post?id=${id}`,
        {
          id: Date.now(),
          createDate: Date.now(),
          name: userName,
          lastname: userLastname,
          phone: userPhone,
          city: userCity,
          appointmentTime: userAppointment,
          selectedDates: selectedDates,
          appointmentDate: toLocalIsoDate(appointmentDate),
          appointmentMode,
        }
      );
      const savedAppointment = response.data?.data || {};
      setConfirmation({
        mode: savedAppointment.appointmentMode || appointmentMode,
        weekday: savedAppointment.selectedDates || selectedDates,
        date: savedAppointment.appointmentDate || toLocalIsoDate(appointmentDate),
        time: savedAppointment.appointmentTime || userAppointment,
      });
      updateEventAppointments(id);
      fetchAppointmentsData();
      resetFormFields();
    } catch (error) {
      console.error(error);
      toast.warning("Nu a fost trimis");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetFormFields = () => {
    setUserName("");
    setLastname("");
    setUserPhone("");
    setUserCity("");
    setUserAppointment("");
    setSelectedDates(dates[0] || "");
    setAppointmentMode("Online");
    setIsScheduling(false);
  };

  const groupAvailableTimeSlotsByHour = (timeSlots, bookedTimes) => {
    const grouped = {};
    timeSlots.forEach((timeSlot) => {
      const [hour, minute] = timeSlot.split(":");
      if (!bookedTimes.includes(timeSlot)) {
        if (!grouped[hour]) {
          grouped[hour] = [];
        }
        grouped[hour].push(minute);
      }
    });

    // Remove hours with no available minutes
    Object.keys(grouped).forEach((hour) => {
      if (grouped[hour].length === 0) {
        delete grouped[hour];
      }
    });

    return grouped;
  };

  const groupedAvailableTimeSlots = groupAvailableTimeSlotsByHour(
    generateTimeSlots(),
    eventAppointments
      ?.filter((appointment) => {
        const appointmentDate = toLocalIsoDate(getNextWeekdayDate(selectedDates));
        return appointment.appointmentDate
          ? appointment.appointmentDate === appointmentDate
          : appointment.selectedDates === selectedDates;
      })
      .map((appointment) => appointment.appointmentTime) || []
  );

  const selectedAppointmentDate = getNextWeekdayDate(selectedDates);
  const selectedAppointmentIsoDate = toLocalIsoDate(selectedAppointmentDate);

  const visibleAppointments = React.useMemo(() =>
    (filteredAppointments || []).slice().sort((a, b) => {
      const dayOrder = {
        "Luni": 1,
        "Marți": 2,
        "Miercuri": 3,
        "Joi": 4,
        "Vineri": 5,
        "Sâmbătă": 6,
        "Duminică": 7,
      };
      const dayDifference = (dayOrder[a.selectedDates] || 0) - (dayOrder[b.selectedDates] || 0);
      if (dayDifference !== 0) return dayDifference;
      return String(a.appointmentTime || "").localeCompare(String(b.appointmentTime || ""));
    }), [filteredAppointments]
  );
  const visibleAppointmentIds = getSelectableAppointmentIds(visibleAppointments);
  const allVisibleAppointmentsSelected = visibleAppointmentIds.length > 0
    && visibleAppointmentIds.every((appointmentId) => selectedAppointmentIds.has(appointmentId));
  const someVisibleAppointmentsSelected = visibleAppointmentIds.some((appointmentId) =>
    selectedAppointmentIds.has(appointmentId)
  );

  React.useEffect(() => {
    if (selectAllCheckboxRef.current) {
      selectAllCheckboxRef.current.indeterminate = someVisibleAppointmentsSelected
        && !allVisibleAppointmentsSelected;
    }
  }, [allVisibleAppointmentsSelected, someVisibleAppointmentsSelected]);

  const selectedAppointments = (eventAppointments || []).filter((appointment) =>
    selectedAppointmentIds.has(getAppointmentDocumentId(appointment))
  );

  const returnDate = (date) => {
    const newDate = new Date(date);
    const formatDate = moment(newDate).format("MMMM Do YYYY");
    return formatDate;
  };

  return (
    <section className="wpo-event-single-section section-padding">
      <ConfirmationDialog
        open={deleteDialogAppointments.length > 0}
        title={deleteDialogAppointments.length > 1
          ? `Ștergi ${deleteDialogAppointments.length} programări?`
          : "Ștergi această programare?"
        }
        description="Această acțiune elimină definitiv înregistrarea din tabel și nu poate fi anulată."
        confirmLabel={deleteDialogAppointments.length > 1 ? "Șterge selecția" : "Șterge programarea"}
        isConfirming={isDeletingAppointments}
        onConfirm={confirmDeleteAppointments}
        onCancel={() => setDeleteDialogAppointments([])}
      />
      {confirmation && (
        <div className="registration-success" role="dialog" aria-modal="true" aria-labelledby="consultation-confirmation-title">
          <div className="registration-success__dialog">
            <button
              type="button"
              className="registration-success__close"
              aria-label="Închide confirmarea"
              onClick={() => setConfirmation(null)}
            >
              <FiX aria-hidden="true" />
            </button>
            <FiCheckCircle className="registration-success__icon" aria-hidden="true" />
            <span className="registration-success__eyebrow">Cerere înregistrată</span>
            <h2 id="consultation-confirmation-title">Abia aștept să te cunosc</h2>
            <p>Te voi contacta pentru confirmarea finală.</p>
            <dl className="registration-success__details">
              <div><dt>Format</dt><dd>{confirmation.mode}</dd></div>
              <div><dt>Zi și dată</dt><dd>{confirmation.weekday}, {formatAppointmentDate(new Date(`${confirmation.date}T12:00:00`))}</dd></div>
              <div><dt>Ora</dt><dd>{confirmation.time}</dd></div>
            </dl>
            <button type="button" className="registration-success__action" onClick={() => setConfirmation(null)}>
              Am înțeles
            </button>
          </div>
        </div>
      )}
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-event-content">
              {isAdmin && (
                <div className="post format-standard-image">
                  {/* <h2>{eventsDetails?.title}</h2> */}
                  {/* <div className="event-media">
                    {eventsDetails && (
                      <img
                        src={eventsDetails.coverImage}
                        alt={eventsDetails.coverImage}
                      // className="styled-image" draggable="false"
                      />
                    )}
                  </div> */}
                  <div className="entry-meta">
                    <ul>
                      <li>
                        <i className="fi flaticon-user"></i> Creat de{" "}
                        {/* <Link to="/blog-single/1">{eventsDetails?.author}</Link>{" "} */}
                        {eventsDetails?.author}
                      </li>
                      <li>
                        <i className="fi flaticon-comment-white-oval-bubble"></i>{" "}
                        Inscrieri {eventsDetails?.appointments}
                      </li>
                      <li>
                        <i className="fi flaticon-calendar"></i>{" "}
                        {eventsDetails ? returnDate(eventsDetails?.createDate) : ""}
                      </li>
                    </ul>
                  </div>

                  {/* {splitText1 && (
                    <div dangerouslySetInnerHTML={{ __html: splitText1 }}></div>
                  )}
                  {highlightedText && (
                    <blockquote
                      dangerouslySetInnerHTML={{ __html: highlightedText }}
                    ></blockquote>
                  )}

                  {splitText2 && (
                    <div dangerouslySetInnerHTML={{ __html: splitText2 }}></div>
                  )} */}
                </div>
              )}
              {isAdmin && (
                <div className="appointments-area">
                  <div className="appointments-section">
                    <h3 className="appointments-title">Toate înscrierile</h3>

                    {/* Butoane pentru zile */}
                    <div className="day-buttons">
                      <button
                        className={`day-button ${selectedDay === "" ? "active" : ""}`}
                        onClick={() => setSelectedDay("")} // Resetează filtrul pentru a afișa toate înscrierile
                      >
                        Toate
                      </button>
                      {dates.map((day, index) => (
                        <button
                          key={index}
                          className={`day-button ${selectedDay === day ? "active" : ""}`}
                          onClick={() => setSelectedDay(day)} // Setează ziua selectată
                        >
                          {day}
                        </button>
                      ))}
                    </div>

                    <div className="appointment-selection-toolbar">
                      <button
                        type="button"
                        className="appointment-bulk-delete-button"
                        onClick={() => requestDeleteAppointments(selectedAppointments)}
                        disabled={!selectedAppointments.length || isDeletingAppointments}
                      >
                        <FiTrash2 aria-hidden="true" />
                        Șterge
                      </button>
                      {selectedAppointmentIds.size > 0 && (
                        <span aria-live="polite">
                          {getAppointmentSelectionLabel(selectedAppointmentIds.size)}
                        </span>
                      )}
                    </div>

                    <ol className="appointments">
                      <li className="appointment">
                        <table className="appointment-table">
                          <thead>
                            <tr>
                              <th className="col-select">
                                <input
                                  ref={selectAllCheckboxRef}
                                  type="checkbox"
                                  checked={allVisibleAppointmentsSelected}
                                  onChange={() => setSelectedAppointmentIds((current) =>
                                    toggleAllAppointmentSelection(current, visibleAppointments)
                                  )}
                                  aria-label="Selectează toate programările afișate"
                                />
                              </th>
                              <th className="col-time">Ora</th>
                              <th className="col-name">Nume</th>
                              <th className="col-lastname">Prenume</th>
                              <th className="col-phone">Telefon</th>
                              <th className="col-city">Oraş</th>
                              <th className="col-actions">Acțiuni</th>
                            </tr>
                          </thead>
                          <tbody>
                            {visibleAppointments.map((appointment, index) => {
                                const appointmentId = getAppointmentDocumentId(appointment);
                                const isDeleting = isDeletingAppointments
                                  && deleteDialogAppointments.some((item) =>
                                    getAppointmentDocumentId(item) === appointmentId
                                  );
                                return (
                                <tr key={appointmentId || index} className={selectedAppointmentIds.has(appointmentId) ? "is-selected" : ""}>
                                  <td className="col-select">
                                    <input
                                      type="checkbox"
                                      checked={selectedAppointmentIds.has(appointmentId)}
                                      onChange={() => setSelectedAppointmentIds((current) =>
                                        toggleAppointmentSelection(current, appointmentId)
                                      )}
                                      aria-label={`Selectează programarea pentru ${appointment.name || "utilizator"} ${appointment.lastname || ""}`.trim()}
                                      disabled={!appointmentId || isDeletingAppointments}
                                    />
                                  </td>
                                  <td className="col-time">{appointment.appointmentTime}</td>
                                  <td className="col-name">{appointment.name}</td>
                                  <td className="col-lastname">{appointment.lastname}</td>
                                  <td className="col-phone">{appointment.phone}</td>
                                  <td className="col-city">{appointment.city}</td>
                                  <td className="col-actions">
                                    <button
                                      type="button"
                                      className="appointment-delete-button"
                                      onClick={() => requestDeleteAppointments([appointment])}
                                      disabled={isDeletingAppointments || !appointmentId}
                                      aria-label={`Șterge programarea pentru ${appointment.name || "utilizator"} ${appointment.lastname || ""}`.trim()}
                                    >
                                      <FiTrash2 aria-hidden="true" />
                                      {isDeleting ? "Se șterge…" : "Șterge"}
                                    </button>
                                  </td>
                                </tr>
                              );})}
                          </tbody>
                        </table>
                      </li>
                    </ol>
                  </div>
                </div>
              )}
              <section className="wpo-appointment-pg-section section-padding-small">
                <div
                  className="wpo-appointment-form-area"
                  style={{ marginBottom: "-100px" }}
                >
                  <div className="appointments-area">
                    <div className="appointment-respond">
                      <RegistrationFormHeading />
                      <p className="appointment-form-kicker">
                        Spune-ne unde te putem contacta, apoi alege intervalul potrivit pentru consultație.
                      </p>

                      <form
                        onSubmit={postAppointment}
                        id="appointmentform"
                        className="appointment-form"
                      >
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label htmlFor="name">Nume</label>
                              <input
                                type="text"
                                id="name"
                                placeholder="Nume"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label htmlFor="lastname">Prenume</label>
                              <input
                                type="text"
                                id="lastname"
                                placeholder="Prenume"
                                value={userLastname}
                                onChange={(e) => setLastname(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label htmlFor="phone">Telefon</label>
                              <input
                                type="tel"
                                id="phone"
                                placeholder="Telefon"
                                value={userPhone}
                                onChange={(e) => setUserPhone(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="form-field">
                              <label>Județ</label>
                              <DropdownWithSearch userCity={userCity} setUserCity={setUserCity} />
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12 col-12">
                            <div className="form-field">
                              {!isScheduling && (
                                <button
                                  type="button"
                                  className="schedule-button"
                                  style={{ paddingTop: "10px" }}
                                  onClick={() => {
                                    setIsScheduling(true); // Show the scheduling interface
                                  }}
                                >
                                  Programează-te
                                </button>

                              )}
                            </div>
                            {isScheduling && (
                              <div className="appointment-scheduler">
                                <span className="form-label scheduler-section-label">Selectează ziua și ora:</span>
                                {/* <div className="col-lg-6 col-md-6 col-4"> */}
                                <div className="date-options">
                                  {dates.map((date, index) => (
                                    <button
                                      type="button"
                                      key={index}
                                      className={`date-option-button ${selectedDates === date ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevent form submission
                                        setSelectedDates(date); // Save the selected date
                                        setIsDateValid(true);
                                      }}
                                    >
                                      {date}
                                    </button>
                                  ))}
                                </div>
                                {!isDateValid && (
                                  <p className="appointment-error">
                                    Te rugăm să selectezi o zi!
                                  </p>
                                )}
                                <div className="schedule-divider" aria-hidden="true"><span /></div>
                                <span className="form-label scheduler-section-label">Ora disponibilă</span>
                                <div className="time-slots-container">
                                  {Object.entries(groupedAvailableTimeSlots)
                                    .sort(([hourA], [hourB]) => parseInt(hourA) - parseInt(hourB))
                                    .map(([hour, availableMinutes], index) => (
                                      availableMinutes.map((minute) => (
                                        <button
                                          type="button"
                                          key={`${hour}:${minute}`}
                                          className={`time-slot-button ${userAppointment === `${hour}:${minute}` ? "active" : ""}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setUserAppointment(`${hour}:${minute}`);
                                            setIsTimeValid(true); // Resetează validarea pentru oră
                                          }}
                                        >
                                          {hour}:{minute}
                                        </button>
                                      ))
                                    ))}
                                </div>
                                <div className="schedule-divider" aria-hidden="true"><span /></div>
                                <div className="appointment-mode" aria-label="Alege modalitatea">
                                  <div className="button-group">
                                    <button
                                      type="button"
                                      className={`option-button ${appointmentMode === "Online" ? "active" : ""}`}
                                      onClick={() => setAppointmentMode("Online")}
                                    >
                                      Online
                                    </button>
                                    {userCity === "Sibiu" && (
                                      <button
                                        type="button"
                                        className={`option-button ${appointmentMode === "Fizic" ? "active" : ""}`}
                                        onClick={() => setAppointmentMode("Fizic")}
                                      >
                                        Fizic
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          {!isTimeValid && (
                                  <p className="appointment-error">
                                    Te rugăm să selectezi o oră!
                                  </p>
                                )}
                        </div>
                          {isScheduling && userAppointment && (
                            <div className="appointment-summary" aria-live="polite">
                              <span className="appointment-summary__label">PROGRAMAREA TA</span>
                              <p>
                                <strong>{appointmentMode}</strong>
                                <span aria-hidden="true">•</span>
                                {selectedDates}, {formatAppointmentDate(selectedAppointmentDate)}
                                <span aria-hidden="true">•</span>
                                ora {userAppointment}
                              </p>
                              <input type="hidden" name="appointmentDate" value={selectedAppointmentIsoDate} />
                            </div>
                          )}
                          <div className="form-submit">
                            <input
                              id="submit"
                              className="submit-button"
                              value={isSubmitting ? "Se trimite…" : "Trimite"}
                              type="submit"
                              disabled={isSubmitting}
                            />
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          {/* <BlogSidebar blLeft={props.blLeft} /> */}
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(EventSingle);
